<script setup>
import OptionValue from "@/components/frontend/ui/OptionValue.vue";


const props = defineProps({
  productCombinations: {
    type: Array,
    required: true,
  },
  selectedCombination: {
    type: Object,
  },
  inline: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['combinationChange']);

const onSelectCombination = (combination) => {
  emit('combinationChange', combination)
};

</script>

<template>
  <div class="form-group">
    <label for="bookingFormSize" class="font-weight-bold text-dark d-block">{{ $t('Size:') }}</label>
    <OptionValue v-for="combination in productCombinations"
                 :key="combination.name"
                 :option-value="combination.name"
                 :selected="selectedCombination?.size === combination?.size && selectedCombination?.color === combination?.color"
                 @change="onSelectCombination(combination)"
                 :class="props.inline ? ' mr-3' : 'btn-block '"
    >
      {{ combination.name }}
    </OptionValue>
  </div>
</template>
